export default __webpack_public_path__ + "static/media/9h.00b72ea5.svg";